export { default } from "./AnchorScroll";
export * from "./AnchorScroll";
